import { bl_fi_generic_doc_line_RowInterface, TimestampTzDatatypeInterface } from "blg-akaun-ts-lib";
import * as moment from "moment";

export class SharedUtilitiesHelperFunctions {
  static currencyFormatter(currency, returnValue?, decimalPlaces = 2, blanket = true) {
    if (currency === null || currency === undefined) return returnValue;

    const parsedCurrency = parseFloat(currency);
    if (isNaN(Number(parsedCurrency))) return currency;

    const roundedCurrency = parseFloat(parsedCurrency.toFixed(decimalPlaces));

    // Treat very small negative values rounded to 0 as 0
    if (roundedCurrency === 0) {
      return roundedCurrency.toFixed(decimalPlaces);
    }

    const formatted = roundedCurrency.toLocaleString('en-US', {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    });

    const value =
      formatted.charAt(0) === "-" && blanket
        ? "(" + formatted.substring(1, formatted.length) + ")"
        : formatted;

    return `${value}`;
  }

  static dateFormatter(date, format = "YYYY-MM-DD") {
    let formatted = moment(date).format(format);
    if (formatted === "Invalid date") {
      formatted = null;
    }
    return `${formatted}`;
  }

  static compareDateFilter(filterLocalDateAtMidnight: Date, cellValue: string): number {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;
    if (dateAsString.indexOf("T")) {
        dateAsString = dateAsString.substring(0, dateAsString.indexOf("T"));
    }
    var dateParts =
        dateAsString.indexOf("/") > 0
            ? dateAsString.split("/")
            : dateAsString.split("-");
    var cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2])
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
        return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
        return 1;
    }
    return 0; // Default return value
  }

  static filterDateParams = {
    comparator: SharedUtilitiesHelperFunctions.compareDateFilter,
    browserDatePicker: true,
    buttons: ["reset"],
    minValidYear: 2000,
    maxValidYear: 2099,
  };

  static filterTextParams = {
    filters: [
      {
        filter: 'agTextColumnFilter',
        display: 'subMenu'
      },
      {
        filter: 'agSetColumnFilter',
        filterParams: {
          buttons: ['reset'],
        }
      }
    ]
  };

  static formatIntegerValue(params: any): string {
    return params.value ? params.value : '0';
  }

  static formatDecimalValue(params: any): string {
    return params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value) : '0.00';
  }

  static decimalFormatterWithBlank(params: any): string {
    return params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value) : '';
  }

  static decimalFormatterNoBlanket(params: any): string {
    return params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value, 0.00, 2, false) : '0.00';
  }

  static decimal8Formatter(params: any): string {
    return params.value ? SharedUtilitiesHelperFunctions.currencyFormatter(params.value, '0.00000000', 8) : '0.00000000';
  }

  static formatDate(params: any): string {
    return params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD') : '';
  }

  static formatDateTime(params: any): string {
    return params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD HH:mm:ss') : '';
  }

  static columnTypes = {
    integerColumn: {
      type: 'numericColumn',
      aggFunc: 'sum',
      enableValue: true,
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'right' },
      headerClass: 'ag-right-aligned-header',
      valueFormatter: SharedUtilitiesHelperFunctions.formatIntegerValue,
      pdfExportOptions: {
        headerStyles: {
          alignment: 'right'
        },
        styles: {
          alignment: 'right',
        }
      }
    },
    integerCenterColumn: {
      type: 'numericColumn',
      aggFunc: 'sum',
      enableValue: true,
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'center' },
      headerClass: 'ag-center-aligned-header',
      valueFormatter: SharedUtilitiesHelperFunctions.formatIntegerValue,
      pdfExportOptions: {
        headerStyles: {
          alignment: 'center'
        },
        styles: {
          alignment: 'center',
        }
      }
    },
    decimalColumn: {
      type: 'numericColumn',
      aggFunc: 'sum',
      enableValue: true,
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'right' },
      headerClass: 'ag-right-aligned-header',
      valueFormatter: SharedUtilitiesHelperFunctions.formatDecimalValue,
      pdfExportOptions: {
        headerStyles: {
          alignment: 'right'
        },
        styles: {
          alignment: 'right',
          currencyFormatter: 'true'
        }
      }
    },
    decimalColumnBlank: {
      type: 'numericColumn',
      aggFunc: 'sum',
      enableValue: true,
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'right' },
      headerClass: 'ag-right-aligned-header',
      valueFormatter: SharedUtilitiesHelperFunctions.decimalFormatterWithBlank,
      pdfExportOptions: {
        headerStyles: {
          alignment: 'right'
        },
        styles: {
          alignment: 'right',
          currencyFormatter: 'true'
        }
      }
    },
    decimalColumnNoBlanket : {
      type: 'numericColumn',
      aggFunc: 'sum',
      enableValue: true,
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'right' },
      headerClass: 'ag-right-aligned-header',
      valueFormatter: SharedUtilitiesHelperFunctions.decimalFormatterNoBlanket,
      pdfExportOptions: {
        headerStyles: {
          alignment: 'right'
        },
        styles: {
          alignment: 'right',
          currencyFormatter: 'true'
        }
      }
    },
    decimal8Column: {
      type: 'numericColumn',
      aggFunc: 'sum',
      enableValue: true,
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'right' },
      headerClass: 'ag-right-aligned-header',
      valueFormatter: SharedUtilitiesHelperFunctions.decimal8Formatter,
      pdfExportOptions: {
        headerStyles: {
          alignment: 'right'
        },
        styles: {
          alignment: 'right',
          currencyFormatter: 'true'
        }
      }
    },
    dateColumn: {
      cellStyle: { textAlign: 'left' },
      valueFormatter: SharedUtilitiesHelperFunctions.formatDate,
      filter: 'agDateColumnFilter',
      filterParams: SharedUtilitiesHelperFunctions.filterDateParams,
      pdfExportOptions: {
        headerStyles: {
          alignment: 'left'
        },
        styles: {
          alignment: 'left',
          dateFormatter: 'true'
        }
      }
    },
    dateTimeColumn: {
      cellStyle: { textAlign: 'left' },
      valueFormatter: SharedUtilitiesHelperFunctions.formatDateTime,
      filter: 'agDateColumnFilter',
      filterParams: SharedUtilitiesHelperFunctions.filterDateParams,
      pdfExportOptions: {
        headerStyles: {
          alignment: 'left'
        },
        styles: {
          alignment: 'left',
          dateTimeFormatter: 'true'
        }
      }
    },
    textColumn: {
      cellStyle: { textAlign: 'left' },
      filter: 'agMultiColumnFilter',
      filterParams: SharedUtilitiesHelperFunctions.filterTextParams
    }
  }

  static getTodayNoTime() {
    // const date = new Date();
    // date.setHours(0, 0, 0, 0);
    // return date;
    return moment().startOf('day');
  }

  static getDateNoTime(val: any) {
    // const date = new Date(val);
    // date.setHours(0, 0, 0, 0);
    // return date;
    const date = moment(val).startOf('day');
    return date;
  }

  static getTodayEndTime() {
    // const date = new Date();
    // date.setHours(0, 0, 0, 0);
    // return date;
    return moment().endOf('day');
  }

  static getDateEndTime(val: any) {
    // const date = new Date(val);
    // date.setHours(23, 59, 59, 999);
    // return date;

    const date = moment(val).endOf('day');
    return date;
  }

  static getFirstDay() {
    // const now = new Date();
    // const date = new Date(now.getFullYear(), now.getMonth(), 1);
    // date.setHours(0, 0, 0, 0);
    // return date;
    const date = moment().startOf('month').startOf('day');
    return date;
  }

  static getLastDay() {
    // const now = new Date();
    // const date = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    // date.setHours(23, 59, 59, 999);
    // return date;
    const date = moment().endOf('month').endOf('day');
    return date;
  }

  static checkNull(obj, returnValue) {
    return obj ? obj : returnValue;
  }

  static checkSerialValid(serialArray: any[]) {
    let hasInvalidSerial = false;
    if (serialArray) {
      if (Array.isArray(serialArray)) {
        if (serialArray.filter(s => s.status === "INVALID").length) {
          hasInvalidSerial = true;
        }
        if (!serialArray.length) {
          hasInvalidSerial = true;
        }
      } else {
        let oldArray: any = serialArray;
        if (!oldArray?.serialNumbers)
          hasInvalidSerial = true;
      }
    } else {
      hasInvalidSerial = true;
    }
    return hasInvalidSerial;
  }

  static checkSerialDuplicate(docline: bl_fi_generic_doc_line_RowInterface[]) {
    let hasDuplicateSerial = false;
    docline.forEach(line => {
      if (line.item_sub_type === "SERIAL_NUMBER") {
        if (line.serial_no) {
          if (Array.isArray(line.serial_no)) {
            if (line.serial_no.filter(s => s.remarks === "Duplicate Serial Number").length) {
              hasDuplicateSerial = true;
            }
          }
        }
      }
    })


    return hasDuplicateSerial;
  }

  static getDropDownGuids(value: any, isMultiple = true) {
    if (isMultiple) {
      const values = SharedUtilitiesHelperFunctions.checkNull(value, '[]');
      if (Array.isArray(values)) {
        return [...values.map(item => item.guid)];
      }
      else {
        return [];
      }
    }
    else {
      return value.guid;
    }
  }

  static removeDuplicate<T>(array: T[], key: string): T[] {
    const map = new Map();
    for (const item of array) {
      map.set(item[key], item);
    }
    return Array.from(map.values());
  }

  static generateEANCode() {
    const date = this.dateFormatter(new Date(), 'YYYYMMDDHHmmss');
    const key = this.calculateEANKey(date);
    console.log('key', key);
    return date + key;
  }

  static calculateEANKey(eanCode: string) {
    let key = 0
    for (let i = 0; i < eanCode.length; i++) {
      let char = eanCode[i]
      let number = Number.parseInt(char)
      if (i % 2 == 0) {
        key += number
      } else {
        key += 3 * number
      }
    }
    key %= 10
    key = (10 - key) % 10
    return key.toString()
  }

  static divide(num1, num2) {
    if (num1 && num2) {
      if (num2 === 0) return 0;
      return num1 / num2;
    }
    return 0;
  }

  static getSystemDefault(guid, name) {
    if (guid === '00000000-0000-0000-0000-000000000000') {
      return 'SYSTEM DEFAULT';
    }
    else {
      return name;
    }
  }

  static exportData(data: any[], filename: string, columnsDefs: any[]) {
    if (!data) return;

    const formatCellValue = (column, item) => {
      if (column.type === 'dateColumn') {
        return SharedUtilitiesHelperFunctions.dateFormatter(item[column.field], 'YYYY-MM-DD');
      } else if (column.type === 'dateTimeColumn') {
        return SharedUtilitiesHelperFunctions.dateFormatter(item[column.field], 'YYYY-MM-DD HH:mm:ss');
      } else {
        return item[column.field];
      }
    };

    const exportData = data.map(item => ({
      ...columnsDefs.reduce((acc, column) => {
        acc[column.headerName] = formatCellValue(column, item);
        return acc;
      }, {}),
    }));

    SharedUtilitiesHelperFunctions.exportCSV(exportData, filename);
  }

  static exportCSV(data: any[], fileName: string) {
    const csv = SharedUtilitiesHelperFunctions.convertToCSV(data);

    // Create a Blob with UTF-8 encoding
    const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], { type: 'text/csv;charset=utf-8' });

    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element to trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;

    // Trigger the download
    document.body.appendChild(a);
    a.click();

    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  static convertToCSV(data: any[]): string {
    const header = Object.keys(data[0]).join(',');
    const rows = this.processRows(data);
    return [header, ...rows].join('\n');
  }

  static processRows(data: any[]): string[] {
      const rows: string[] = [];
      for (const item of data) {
          const processedRow = this.processRowValues(item);
          rows.push(processedRow);
      }
      return rows;
  }

  static processRowValues(item: any): string {
      const values: any[] = Object.values(item);
      const processedValues: any[] = [];
      
      for (const value of values) {
          const processedValue = this.formatValue(value);
          processedValues.push(processedValue);
      }
      
      return processedValues.join(',');
  }

  static formatValue(value: any): any {
    if (typeof value === 'string') {
        let formattedValue = value.replace(/"/g, '""');
        
        if (formattedValue.includes(',') || 
            formattedValue.includes('"') || 
            /[^\x00-\x7F]/.test(formattedValue)) {
            return `"${formattedValue}"`;
        }
        return formattedValue;
    }
    return value;
  }

  static isValidGuid(value: string): boolean {
    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return !!value && typeof value === 'string' && guidRegex.test(value);
  }

  static getDefaultExportParams() {
    return {
      processCellCallback: SharedUtilitiesHelperFunctions.processCellCallback,
    };
  }

  static processCellCallback(params) {
    if (params.column.getColDef().type === 'dateColumn') {
      const result = params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value) : '';
      return result;
    }
    else if (params.column.getColDef().type === 'dateTimeColumn') {
      const result = params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD HH:mm:ss') : '';
      return result;
    }
    return params.value;
  }

  static isNullOrEmptyObject(value: any): boolean {
    return value === null || (typeof value === 'object' && Object.keys(value).length === 0);
  }

  static concatenateWithDelimiter(arr: string[], delimiter: string): string {
    const newArr = arr.filter(str => (str && str.trim() !== '')).join(delimiter);
    return newArr;
  }

  static getJournalLineDescr(arr: string[]) {
    const filter = ['AUTO CREATED FROM JOURNAL POSTING JOB PROCESSOR','AUTO CREATED FROM MONTH END PROCESSING',
      'AUTO CREATED FROM RETAINED EARNINGS PROCESSING', 'AUTO CREATED FROM COGS PROCESSING', 'AUTO CREATED FROM REVERSE JOURNAL POSTING JOB PROCESSOR']

    const newArr = arr.filter(str => (str && str.trim() !== '' && filter.indexOf(str) < 0)).join('|');
    return newArr;
  }

  static convertToTimestampTz(date: string | Date): TimestampTzDatatypeInterface {
    const newDate = new Date(date) as TimestampTzDatatypeInterface;
    return newDate;
  }
  
  static autoSizeAllColumns(params) {
    const allColumnIds: string[] = params.columnApi.getAllColumns().map(column => column.getColId());

      // Auto-size all columns
      params.columnApi.autoSizeColumns(allColumnIds);

    const allColumns = params.columnApi.getAllColumns();
    allColumns.forEach(column => {
      const currentWidth = column.getActualWidth(); // Get the actual width of the column

      // Set width to 200 if the current width exceeds 200
      if (currentWidth > 200) {
        params.columnApi.setColumnWidth(column.getColId(), 200);
      }
    });
  }

  static onDecimalKeyPress(event: KeyboardEvent, decimal: number = 2) {
    const input = event.target as HTMLInputElement;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow only numbers and decimal points
    if (!/^[0-9.]$/.test(inputChar)) {
      event.preventDefault(); // Disallow non-numeric characters
    }

    // Ensure only one decimal point is allowed
    if (input.value.includes('.') && inputChar === '.') {
      event.preventDefault(); // Disallow multiple decimal points
    }

    // Prevent input if decimal part exceeds the specified limit
    const parts = input.value.split('.');
    if (parts[1]?.length >= decimal && input.selectionStart > input.value.indexOf('.')) {
      event.preventDefault(); // Block input beyond 2 decimal places
    }
  }

  static getTargetsByPermission(userPermissionTarget$, readPermission, targetTable) {
    let targets = [];
    userPermissionTarget$.subscribe(permissionObject => {
      let target = permissionObject.filter(
        (target) => target.permDfn === readPermission
      );
      let adminCreatePermissionTarget = permissionObject.filter(
        (target) => target.permDfn === 'TNT_TENANT_ADMIN'
      );
      let ownerCreatePermissionTarget = permissionObject.filter(
        (target) => target.permDfn === 'TNT_TENANT_OWNER'
      );

      if ( adminCreatePermissionTarget[0]?.hasPermission
        || ownerCreatePermissionTarget[0]?.hasPermission) {
        //console.log("has admin/owner permission");
        targets = [];
      } else {
        //console.log("has targets");
        targets = target[0]?.target !== null && Object.keys(target[0]?.target || {}).length !== 0
        ? target[0]?.target[targetTable]
        : [];
      }
    });
    //console.log('get targets', targets);
    return targets;
  }
}